import React from 'react';
import { Link } from 'react-router-dom';

interface MastersCardsProps {
  title: string;
  icon: React.ReactNode;
  bgColor: string;
  to?: string; // optional
}

const MastersCards: React.FC<MastersCardsProps> = ({ title, icon, bgColor, to }) => {
  const CardContent = (
    <div className='border-2 bg-white shadow-lg border-gray-300 h-40 rounded-2xl flex flex-col items-center justify-center mt-10 text-center cursor-pointer hover:shadow-lg transition-shadow duration-200'>
      <div className={`border w-16 h-16 flex items-center justify-center rounded-xl shadow-sm mb-4 ${bgColor}`}>
        {icon}
      </div>
      <div>
        <h4 className='text-md font-semibold text-gray-700'>{title}</h4>
      </div>
    </div>
  );

  // Only render Link if "to" is provided
  return to ? <Link to={to}>{CardContent}</Link> : CardContent;
};

export default MastersCards;
